import React, { useEffect, useState } from "react";
import axios from "axios";

import { useQuery } from "@tanstack/react-query";
import Constants from "../../../utils/Constants";
import SplashScreen from "../../../components/loader/SplashScreen/SplashScreen";
import { Export, Restart } from "@carbon/icons-react";
import SearchHead from "../../../components/custom/SearchHead";
import ReactPaginate from "react-paginate";

const TestDrive = () => {
  const [page, setPage] = useState(1);
  const [loader, Setloader] = useState(false);
  const [searchparam , setsearchparam] = useState(null);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const TestDriveApi = (page) => {
    return axios({
      method: "get",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      params: {
        page: page || 1,
        ...(searchparam ? { search: searchparam } : {}),
        ...(startDate ? { 'createdAt[gte]': startDate } : {}),
        ...(endDate ? { 'createdAt[lte]': endDate } : {}),
      },
      url: Constants.url + "test-drive",
    }).then((res) => {
      return res.data.data;
    });
  };

  const {
    data: TDdata,
    isLoading,
    refetch,
  } = useQuery({
    queryFn: () => TestDriveApi(page),
    queryKey: ["TDdata", page],
    staleTime: Infinity,
    cacheTime: 1000 * 60 * 60,
  });

  const headers = [
    { label: "First Name", key: "firstName" },
    { label: "Last Name", key: "lastName" },
    { label: "Email", key: "email" },
    { label: "Phone", key: "mobileNo" },
    { label: "City", key: "city" },
    { label: "model", key: "model" },
    { label: "Product Variant", key: "productVariant" },
    { label: "subscribed", key: "subscribed" },
    { label: "variant", key: "hearing" },
    { label: "CNIC", key: "cnic" },
    { label: "Dealership", key: "dealership" },
    { label: "timeline", key: "purchaseTimeline" },
    { label: "Created At", key: "createdAt" },
  ];


  useEffect(() => {
    refetch()
  } , [searchparam , startDate , endDate])

  const Refresh = () => {
    Setloader(true);
    refetch().then(() => {
      Setloader(false);
    });
  };

  return (
    <>
      {!isLoading && !loader ? (
        <div className="uk-grid" uk-grid="">
          <div className="uk-width-1-1">
            <SearchHead
              searchparam={searchparam}
              RefreshFunc={Refresh}
              headers={headers}
              CsvData={TDdata.drives}
              Filename={"TestDrive_data.csv"}
              setsearchparam={setsearchparam}
              endpoint="test-drive"
              startDate={startDate}
              endDate={endDate}
              setStartdate={setStartDate}
              setEndDate={setEndDate}
            />
            <div className="analyticsTableWrp uk-overflow-auto ">
              <table className="uk-table uk-table-striped  ">
                <thead className="table-header-shadow ">
                  <tr>
                    <th>S.No</th>
                    <th>first Name</th>
                    <th>last Name</th>
                    <th>phone</th>
                    <th>email</th>
                    <th>City</th>
                    <th>model</th>
                    {/* <th> Product Variant</th> */}
                    <th> Current Vehicle</th>
                    <th>subscribed</th>
                    <th>CNIC</th>
                    <th>Dealership</th>
                    <th>Timeline</th>
                    <th>Created At</th>
                  </tr>
                </thead>

                <tbody>
                  {TDdata.drives.map((item, index) => (
                    <tr key={item}>
                      <td>{(page - 1) * 100 + (index + 1)}</td>
                      <td>{item.firstName || "-"}</td>
                      <td>{item.lastName || "-"}</td>
                      <td>{item.mobileNo || "-"}</td>
                      <td>{item.email || "-"}</td>
                      <td>{item.city || "-"}</td>

                      <td>{item.model || "-"}</td>
                      {/* <td>{item.productVariant || "-"}</td> */}
                      <td>{item.currentVehicle}</td>
                      <td>{item.subscribed ? "True" : "False"}</td>
                      <td>{item.cnic || "-"}</td>
                      <td>{item.dealership || "-"}</td>
                      <td>{item.purchaseTimeline}</td>
                      <td>
                        {item.createdAt
                          ? new Date(item.createdAt).toLocaleString("en-US", {
                              year: "numeric",
                              month: "numeric",
                              day: "numeric",
                              hour: "2-digit",
                              minute: "2-digit",
                              hour12: true,
                            })
                          : "-"}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className=" paginationcard uk-card uk-card-default ">
                <ReactPaginate
                  previousLabel={"←"}
                  nextLabel={"→"}
                  breakLabel={"..."}
                  breakClassName={"break-me"}
                  pageCount={Math.ceil(TDdata.totalRecords / 100)}
                  marginPagesDisplayed={1}
                  pageRangeDisplayed={2}
                  onPageChange={(e) => setPage(e.selected + 1)}
                  containerClassName={"pagination"}
                  activeClassName={"active"}
                  forcePage={page - 1}
                />
              </div>
            </div>
          </div>
        </div>
      ) : (
        <SplashScreen />
      )}
    </>
  );
};

export default TestDrive;
